<div>

    <!-- Title -->
    <div class="p-b-16 d-flex-between">
        <div>
            <span *ngIf="!isVerificationSuccess" class="font-h6">Datos para crear tu cuenta</span>
            <span *ngIf="isVerificationSuccess" class="font-h6">Código de verificación</span>
        </div>
        <app-test-modal></app-test-modal>
    </div>

    <form class="form-horizontal form-material" [formGroup]="registerForm" (ngSubmit)="onSubmit()" #formDir="ngForm">
        <div *ngIf="!isVerificationSuccess">

            <!-- Country Selection -->
            <div *ngIf="!phoneReceived" class="form-group">
                <label class="font-l1">Selecciona el país</label>
                <select class="form-control" formControlName="country" (change)="onCountryChange($event)">
                    <option [value]="-1">Seleccioná el País</option>
                    <option [value]="1">Costa Rica</option>
                    <option [value]="2">Panamá</option>
                </select>
                <div class="form-control-feedback" *ngIf="invalidCountry">
                    <small class="text-danger">
                        El país es requerido
                    </small>
                </div>
            </div>

            <!-- Phone -->
            <div *ngIf="!phoneReceived">
                <app-phone-input [formGroup]="registerForm" [label]="'Teléfono celular'"
                    (change)="onPhoneChange($event)" (blur)="onCheckPhone()">
                </app-phone-input>
                <div *ngIf="customerPhoneDuplicated">
                    <!-- Pendiente de completar cuenta -->
                    <div *ngIf="customerPhoneDuplicated.isPending" class="has-danger" style="margin: -16px 0 0 0;">
                        <div class="form-control-feedback">
                            <small>
                                Este teléfono ya está vinculado a una cuenta, debés completar el proceso de registro de
                                tu cuenta.
                            </small>
                        </div>
                        <!-- <div (click)="onResetPassword()" style="margin: 0 0 16px 0;">
                            <a class="cursor-pointer font-12">
                                Por favor ir a <b>recuperar contraseña</b> para completar el proceso aquí.
                            </a>
                        </div>  -->
                    </div>
                    <!-- Ya tiene cuenta registrada  -->
                    <div *ngIf="!customerPhoneDuplicated.isPending" class="has-danger" style="margin: -16px 0 0 0;">
                        <div class="form-control-feedback">
                            <small style="font-size: 15px;">
                                Este teléfono ya está vinculado a una cuenta, inicia sesión con tu teléfono
                            </small>
                        </div>
                        <div style="margin: 0 0 16px 0;">
                            <span class="cursor-pointer font-12">
                                Si creés que alguien utilizó tu número, contactanos info@somosgivi.com.
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="!customerPhoneDuplicated">
                <!-- Nombre (solo si requestName) -->
                <div *ngIf="requestName" class="form-group" [ngClass]="{'has-danger': invalidName}">
                    <label class="font-l1">Nombre</label>
                    <input class="form-control" type="text" placeholder="Nombre" formControlName="name" maxlength="50">
                    <div class="form-control-feedback" *ngIf="invalidName">
                        <small *ngIf="name.errors?.required">El nombre es requerido</small>
                    </div>
                </div>
                <!-- Apellido (solo si requestName) -->
                <div *ngIf="requestName" class="form-group" [ngClass]="{'has-danger': invalidLastName}">
                    <label class="font-l1">Apellido</label>
                    <input class="form-control" type="text" placeholder="Apellido" formControlName="lastName" maxlength="50">
                    <div class="form-control-feedback" *ngIf="invalidLastName">
                        <small *ngIf="lastName.errors?.required">El apellido es requerido</small>
                    </div>
                </div>
                <!-- Email -->
                <div class="form-group" [ngClass]="{'has-danger': invalidEmail || emailDuplicated}">
                    <label class="font-l1">Email</label>
                    <input class="form-control" type="email" placeholder="Email" formControlName="email"
                        autocomplete="new-password" (input)="onCheckEmail()">
                    <div class="form-control-feedback" *ngIf="invalidEmail">
                        <small *ngIf="email.errors?.email">
                            Email inválido
                        </small>
                        <small *ngIf="email.errors?.required">
                            El email es requerido
                        </small>
                    </div>
                    <div *ngIf="!invalidEmail && emailDuplicated" class="form-control-feedback">
                        <small style="font-size: 15px;">
                            El email ya está vinculado a una cuenta, inicia sesión con tu email
                        </small>
                    </div>
                </div>

                <!-- Términos y Condiciones -->
                <div class="m-t-24">
                    <div class="text-muted font-12">
                        Al crear esta cuenta estás aceptando estos
                    </div>
                    <div>
                        <a class="text-purple cursor-pointer font-12"
                            href="https://www.somosgivi.com/t%C3%A9rminos-y-condiciones" target="_blank">
                            Términos y Condiciones
                        </a>
                        <span class="text-muted font-12"> y </span>
                        <a class="text-purple cursor-pointer font-12" href="https://www.somosgivi.com/privacypolicy"
                            target="_blank">
                            Políticas de Privacidad
                        </a>
                    </div>
                </div>

                <!-- button valid verify -->
                <div class="form-group m-t-24 text-center">
                    <button *ngIf="isVerificationWithPhone" class="btn btn-primary w-100" type="button"
                        [disabled]="isInvalid()" (click)="onVerifyPhone()">
                        Continuar
                    </button>
                    <button *ngIf="!isVerificationWithPhone" class="btn btn-primary w-100" type="button"
                        [disabled]="isInvalid()" (click)="onVerifyEmail()">
                        Continuar
                    </button>
                </div>
            </div>
        </div>

        <!-- El código de confirmación fue enviado y hay que verificarlo -->
        <div *ngIf="isVerificationSuccess">
            <div class="text-muted text-left font-c1 p-b-16">
                Enviado a:
                <b *ngIf="isVerificationWithPhone">{{phone.value?.dialCode}} {{phone.value?.number}}</b>
                <b *ngIf="!isVerificationWithPhone">{{email.value}}</b><br>
                <small class="text-muted">Esto puede tomar algunos minutos</small>
            </div>

            <app-code-input [formGroup]="registerForm" [onReset]="onReset"></app-code-input>
            <div *ngIf="codeAlert" class="has-danger text-center">
                <small class="form-control-feedback text-primary">
                    {{codeAlert}}
                </small>
            </div>

            <ng-container *ngIf="sendEmailCount >= 5">
                <div class="font-12 text-primary text-center mt-2"
                    *ngIf="codeAwaitSeconds > 0">
                    {{formatTime(codeAwaitSeconds)}} para solicitar otro código por SMS
                </div>

                
                <div class="m-t-24 text-center" *ngIf="codeAwaitSeconds <= 0 && !sendedCode">
                    <div class="text-muted font-b2">¿No recibiste el código por SMS?</div>
                    <div class="m-t-10">
                        <a class="font-b2 text-purple" href="javascript:void(0)" (click)="onVerifyPhone(true)">Volver a
                            enviar</a>
                    </div>
                </div>
            </ng-container> 

            <div class="text-center">
                <!--
                <div class="m-t-15 m-b-5 text-muted font-b2">O</div>
                -->
                <div class="text-muted font-b2">Podemos enviártelo a tu email:</div>
                <div class="m-t-10">
                    <a class="font-b2 text-purple" href="javascript:void(0)" (click)="onVerifyEmail(true)">Reenviarlo por
                        email</a>
                </div>
            </div>

            <!-- button submit crear cuenta -->
            <div class="form-group m-t-24 text-center">
                <button class="btn btn-primary btn-med w-100" type="submit"
                    [disabled]="isInvalidCode()">Continuar</button>
            </div>
        </div>
    </form>


    <!-- Login -->
    <!-- Solo se muestra si el registro no viene del modal de recibir un Givi -->
    <div *ngIf="!emailReceived && !phoneReceived" class="form-group m-t-24 text-center">
        <span class="text-muted m-l-10 font-b2">¿Tenés cuenta?</span>
        <a [routerLink]="['/login']" class="text-purple font-b2"> Ir a iniciar sesión</a>
    </div>

</div>

<ng-template #modalSelectedTypeVerify let-modal>
    <div class="modal-body">
        <div class="d-flex">
            <button class="close" (click)="modal.dismiss()">
                <i class="fa fa-times m-t-5 m-r-10"></i>
            </button>
        </div>

        <div class="d-flex justify-content-center">
            <img src="assets/images/iconoprivacidad.png" style="width: 25%;">
        </div>

        <div class="text-center m-t-10">
            <p>¿Desea recibir el código de autenticación en su número de teléfono o en su correo electrónico?</p>
        </div>
        <!-- button verify sms -->
        <div class="m-t-24 text-center d-flex justify-content-center">
            <button class="btn btn-outline-primary btn-sm" type="button" [disabled]="isInvalid()" (click)="onVerifyPhone()">
                SMS
            </button>
            <button class="btn btn-outline-primary btn-sm m-l-10" type="button" [disabled]="isInvalid()" (click)="onVerifyEmail()">
                Email
            </button>
        </div>
    </div>
</ng-template>